<template>
    <app-wrapper>
        <app-header :loan="loan" medium-max-width="max-w-1000">
            <template #navigation>
                <div class="max-w-200">
                    <h5 class="font-zen-dots text-white">
                        <AppLogo />
                    </h5>
                </div>
            </template>
            <template #top>
                <div class="w-full flex items-center">
                    <div class="flex-auto">
                        Your desired loan amount
                        <h2 class="mb-0 mt-2 md:mt-4 md:text-6xl">{{ loan.amount | money(0) }}</h2>
                    </div>
                    <div class="flex-initial">
                        <i class="fa fa-check-circle text-success text-7xl"/>
                    </div>
                </div>
            </template>
        </app-header>
        <app-body medium-max-width="max-w-500" footer>

            <template #title>
                <p class="text-base md:text-sm mb-2 font-medium">Final Step</p>
                Verify Bank Account
            </template>

            <template #text>
<!--                <template v-if="! showBanking && ! showManual">-->
<!--                    Link your bank account for personalized loan offers based on real-time financial information.-->
<!--                </template>-->
<!--                <template v-else-if="showBanking">-->
<!--                    Please verify your bank account through which you receive your income. This will help us finalize your approval.-->
<!--                </template>-->
<!--                <template v-else-if="showManual">-->
<!--                    Please input your bank account details through which you receive your income. This will help us finalize your approval.-->
<!--                </template>-->
                Once your account is verified and approved, you will get funded within 24 hours.

                <WaitingProgressBar :show-progress="proceeding" />
            </template> 

            <template #main>
                <div v-if="! showBanking && ! showManual" class="mt-7">

                    <div @click.prevent="onInstantConnectionClick"
                         class="bg-white border-gray-300 cursor-pointer shadow-lg border p-3 rounded-lg flex space-x-3">
                        <div class="bg-terciary rounded-md px-3 flex justify-center items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="text-action w-8 h-8">
                                <path fill-rule="evenodd" d="M14.615 1.595a.75.75 0 01.359.852L12.982 9.75h7.268a.75.75 0 01.548 1.262l-10.5 11.25a.75.75 0 01-1.272-.71l1.992-7.302H3.75a.75.75 0 01-.548-1.262l10.5-11.25a.75.75 0 01.913-.143z" clip-rule="evenodd"/>
                            </svg>
                        </div>
                        <div class="flex-auto space-y-1 md:py-2">
                            <p class="text-lg font-bold">Instant Connection</p>
                            <p>Click here to securely verify your bank account</p>
                        </div>
                        <div class="flex items-center justify-center">
                            <span class="bg-green-100 text-green-500 rounded-lg p-2 mr-4 font-bold">FAST</span>
                        </div>
                    </div>

                    <ManualBankingWarning v-if="loan.signup_state_name !== 'leadgen_plaid'" class="mt-3" />

                    <div v-if="loan.signup_state_name !== 'leadgen_plaid'" @click.prevent="onManualConnectionClick"
                         class="bg-gray-100 hover:bg-white mt-3 border-gray-300 cursor-pointer shadow-lg border p-3 rounded-lg flex space-x-3" data-testid="manual">
                        <div class="bg-primary rounded-md px-3 flex justify-center items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="text-white w-8 h-8">
                                <path d="M11.584 2.376a.75.75 0 01.832 0l9 6a.75.75 0 11-.832 1.248L12 3.901 3.416 9.624a.75.75 0 01-.832-1.248l9-6z"/>
                                <path fill-rule="evenodd" d="M20.25 10.332v9.918H21a.75.75 0 010 1.5H3a.75.75 0 010-1.5h.75v-9.918a.75.75 0 01.634-.74A49.109 49.109 0 0112 9c2.59 0 5.134.202 7.616.592a.75.75 0 01.634.74zm-7.5 2.418a.75.75 0 00-1.5 0v6.75a.75.75 0 001.5 0v-6.75zm3-.75a.75.75 0 01.75.75v6.75a.75.75 0 01-1.5 0v-6.75a.75.75 0 01.75-.75zM9 12.75a.75.75 0 00-1.5 0v6.75a.75.75 0 001.5 0v-6.75z" clip-rule="evenodd"/>
                                <path d="M12 7.875a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25z"/>
                            </svg>
                        </div>
                        <div class="flex-auto space-y-1 py-2">
                            <p class="text-xl font-bold">Manual</p>
                            <p>Requires bank statements</p>
                        </div>
                    </div>

                </div>
                <div v-else-if="showBanking && loan.banking_vendor?.name === 'mx'" class="mt-7 space-y-7">

                    <div id="mx-connect-widget" :key="'mx'"/>

                    <div class="flex items-center bg-gray-50 shadow rounded-lg md:h-full">
                        <div class="flex-auto py-6 px-6">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="15" viewBox="0 0 32 15" fill="currentColor">
                                <path d="M28.7354 0H31.9438C31.9924 0 32.0178 0.0566906 31.9861 0.0881854L26.5584 6.98345C26.5415 7.00024 26.5415 7.03384 26.5584 7.04854L31.9861 13.9438C32.0178 13.9837 31.9861 14.0341 31.9438 14.0341H28.7354C28.7206 14.0341 28.7037 14.0257 28.6953 14.0089L24.9056 9.0894C24.8887 9.0663 24.8485 9.0663 24.8232 9.0894L21.0335 14.0089C21.0251 14.0257 21.0103 14.0341 20.9934 14.0341H17.785C17.7427 14.0341 17.7216 13.9753 17.7427 13.9438L23.1704 7.04854C23.1852 7.03384 23.1852 7.00024 23.1704 6.98345L17.7427 0.0881854C17.7131 0.048292 17.7427 0 17.785 0H20.9934C21.0103 0 21.0251 0.00839861 21.0335 0.0251958L24.8232 4.94258C24.8401 4.96778 24.8803 4.96778 24.9056 4.94258L28.6953 0.0251958C28.7037 0.00839861 28.7206 0 28.7354 0Z"></path>
                                <path d="M16.485 13.7264L18.5964 11.1396C18.6112 11.1228 18.6197 11.0997 18.6197 11.0829L17.0007 0.0828045C16.9922 0.042911 16.9584 0.00931658 16.9182 0.00931658H14.7814C14.7476 0.00931658 14.7159 0.0261138 14.7074 0.0576086L9.63272 10.3354C9.60102 10.4005 9.51013 10.4005 9.48688 10.3354L4.36145 0.0576086C4.34454 0.0261138 4.32129 0.00931658 4.28959 0.00931658H2.12951C2.08723 0.00931658 2.05342 0.042911 2.04496 0.0828045L0.00112912 13.9447C-0.0073252 13.993 0.0328328 14.0413 0.0835588 14.0413H2.57758C2.61986 14.0413 2.66213 14.0098 2.66213 13.9699L3.89435 4.9603C3.9028 4.87841 4.01905 4.86372 4.05286 4.9372L8.57593 14.0014C8.59284 14.035 8.6182 14.0497 8.6499 14.0497H10.419C10.4507 14.0497 10.4845 14.035 10.4929 14.0014L14.9611 4.9855C14.9928 4.91201 15.109 4.9288 15.1175 5.00859L16.3349 13.6844C16.3433 13.7578 16.4427 13.7809 16.485 13.7264Z"></path>
                            </svg>
                        </div>
                        <div class="flex-auto">
                            <p class="pr-4 md:pr-6 leading-5">Your information is secured by MX's bank level security standards.</p>
                        </div>
                    </div>

                </div>
                <div v-else-if="showBanking && loan.banking_vendor?.name === 'plaid'" class="mt-7 space-y-7">

                    <div v-if="plaidLoading" class="flex justify-center">
                        <i class="fa fa-circle-notch fa-spin text-3xl"/>
                    </div>

                    <div @click.prevent="plaid.open()" class="flex cursor-pointer items-center bg-gray-50 shadow rounded-lg md:h-full">

                        <div class="flex-auto py-6 px-6">
                            <svg class="h-8" viewBox="0 0 126 48" xmlns="http://www.w3.org/2000/svg">
                                <g fill="#111" fill-rule="evenodd">
                                    <path d="M66.248 16.268c-1.057-.889-2.861-1.333-5.413-1.333h-5.756v17.788h4.304v-5.575h1.928c2.34 0 4.056-.515 5.148-1.546 1.23-1.155 1.849-2.693 1.849-4.613 0-1.991-.687-3.565-2.06-4.721m-5.044 6.855h-1.821V18.96h1.636c1.99 0 2.985.698 2.985 2.094 0 1.378-.934 2.068-2.8 2.068M75.673 14.934h-4.488v17.788h9.69v-4.026h-5.202zM89.668 14.934l-7.05 17.788h4.832l.924-2.586H94.5l.845 2.586h4.886l-7-17.788zm-.053 11.601l1.849-6.08 1.82 6.08z"></path>
                                    <path
                                        d="M102.473 32.722h4.489V14.934h-4.489zM124.39 18.268a7.376 7.376 0 00-2.14-2.053c-1.355-.854-3.204-1.28-5.545-1.28h-5.914v17.787h6.918c2.5 0 4.506-.817 6.02-2.453 1.514-1.635 2.27-3.805 2.27-6.508 0-2.15-.537-3.981-1.61-5.493m-7.182 10.427h-1.927v-9.734h1.954c1.373 0 2.428.43 3.168 1.287.74.857 1.11 2.073 1.11 3.647 0 3.2-1.435 4.8-4.305 4.8M18.637 0L4.09 3.81.081 18.439l5.014 5.148L0 28.65l3.773 14.693 14.484 4.047 5.096-5.064 5.014 5.147 14.547-3.81 4.008-14.63-5.013-5.146 5.095-5.063L43.231 4.13 28.745.083l-5.094 5.063zM9.71 6.624l7.663-2.008 3.351 3.44-4.887 4.856zm16.822 1.478l3.405-3.383 7.63 2.132-6.227 6.187zM4.672 17.238l2.111-7.705 6.125 6.288-4.886 4.856zm29.547-1.243l6.227-6.189 1.986 7.74-3.404 3.384zm-15.502-.127l4.887-4.856 4.807 4.936-4.886 4.856zm-7.814 7.765l4.886-4.856 4.81 4.936-4.888 4.856zm15.503.127l4.886-4.856L36.1 23.84l-4.887 4.856zM4.57 29.927l3.406-3.385 4.807 4.937-6.225 6.186zm14.021 1.598l4.887-4.856 4.808 4.936-4.886 4.856zm15.502.128l4.887-4.856 3.351 3.439-2.11 7.705zm-24.656 8.97l6.226-6.189 4.81 4.936-3.406 3.385zm16.843-1.206l4.886-4.856 6.126 6.289-7.662 2.007z"></path>
                                </g>
                            </svg>
                        </div>
                        <div class="flex-auto">
                            <p class="pr-4 md:pr-6 leading-5">Your information is secured by Plaid's bank level security standards.</p>
                        </div>
                    </div>

                </div>
                <div v-else-if="showManual" class="mt-7 md:h-full">

                    <ManualBankingWarning class="mb-4" />

                    <div class="bg-gray-50 border-gray-300 border p-4 rounded-lg">
                        <div>
                            <div class="md:flex justify-between mb-3">
                                <div class="flex-initial">
                                    <label for="official_name">Name of Bank</label>
                                </div>
                                <div v-if="getError('official_name')" class="flex-initial mt-2 sm:mt-0 md:ml-2 font-semibold text-red-500">
                                    {{ getError('official_name') }}
                                </div>
                            </div>
                            <div class="md:flex">
                                <input type="text"
                                       tabindex="1"
                                       id="official_name"
                                       name="official_name"
                                       placeholder="Name of Bank"
                                       class="input-field w-full md:mr-1"
                                       v-model="manualForm.official_name"
                                />
                            </div>
                        </div>

                        <div class="mt-4">
                            <div class="md:flex justify-between mb-3">
                                <div class="flex-initial">
                                    <label for="account_number">Account Number</label>
                                </div>
                                <div v-if="getError('account_number')" class="flex-initial mt-2 sm:mt-0 md:ml-2 font-semibold text-red-500">
                                    {{ getError('account_number') }}
                                </div>
                            </div>
                            <div class="md:flex">
                                <input type="text"
                                       tabindex="1"
                                       id="account_number"
                                       name="account_number"
                                       placeholder="Account Number"
                                       class="input-field w-full md:mr-1"
                                       v-model="manualForm.account_number"
                                />
                                <input type="text"
                                       tabindex="1"
                                       id="account_number"
                                       name="account_number_confirmation"
                                       placeholder="Confirmation"
                                       class="input-field w-full mt-1 md:mt-0 md:ml-1"
                                       v-model="manualForm.account_number_confirmation"
                                />
                            </div>
                        </div>

                        <div class="mt-4">
                            <div class="md:flex justify-between mb-3">
                                <div class="flex-initial">
                                    <label for="routing_number">Routing Number</label>
                                </div>
                                <div v-if="getError('routing_number')" class="flex-initial mt-2 sm:mt-0 md:ml-2 font-semibold text-red-500">
                                    {{ getError('routing_number') }}
                                </div>
                            </div>
                            <div class="md:flex">
                                <input type="text"
                                       tabindex="1"
                                       id="routing_number"
                                       name="routing_number"
                                       placeholder="Routing Number"
                                       class="input-field w-full md:mr-1"
                                       v-model="manualForm.routing_number"
                                />
                                <input type="text"
                                       tabindex="1"
                                       id="routing_number"
                                       name="routing_number_confirmation"
                                       placeholder="Confirmation"
                                       class="input-field w-full mt-1 md:mt-0 md:ml-1"
                                       v-model="manualForm.routing_number_confirmation"
                                />
                            </div>
                        </div>

                        <div class="mt-4">
                            <div class="md:flex justify-between mb-3">
                                <div class="flex-initial">
                                    <label for="bank_statement">Bank Statement</label>
                                </div>
                                <div v-if="getError('bank_statement')" class="flex-initial mt-2 sm:mt-0 md:ml-2 font-semibold text-red-500">
                                    {{ getError('bank_statement') }}
                                </div>
                            </div>
                            <div class="md:flex">
                                <input
                                    ref="fileUpload"
                                    type="file"
                                    data-testid="bank_statement"
                                    name="bank_statement"
                                    id="bank_statement"
                                    @change="onBankStatementChange"
                                    class="hidden"/>
                                <div @click.prevent="onUploadClick" class="bg-white p-14 w-full flex justify-center items-center font-semibold text-lg border-2 border-dashed border-gray-200 rounded-lg cursor-pointer">
                                    <template v-if="! fileName">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8 mr-2">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5"/>
                                        </svg>
                                        Upload Document <small class="text-red-500 inline-block ml-1"> (PDF Only)</small>
                                    </template>
                                    <template v-else>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8 mr-2">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M10.125 2.25h-4.5c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125v-9M10.125 2.25h.375a9 9 0 019 9v.375M10.125 2.25A3.375 3.375 0 0113.5 5.625v1.5c0 .621.504 1.125 1.125 1.125h1.5a3.375 3.375 0 013.375 3.375M9 15l2.25 2.25L15 12"/>
                                        </svg>
                                        {{ fileName }}
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>

                    <button tabindex="12" @click="onSubmitManualClick" id="apply" role="button" class="w-full shadow-action font-semibold text-lg bg-action rounded mt-5 text-white py-3">
                        <template v-if="! loading">
                            Submit
                        </template>
                        <template v-else>
                            <i class="fa fa-circle-notch fa-spin"/>
                        </template>
                    </button>

                </div>

                <div v-if="showBanking" class="mt-5 flex flex-col items-center justify-center space-y-2">
                    <a href="#" @click.prevent="refresh" class="text-sm font-medium cursor-pointer underline text-black">Go Back</a>
                    <span class="text-gray-500">If you don't see your bank...</span>
                </div>
                <div v-else-if="showManual" class="mt-5 flex flex-col items-center justify-center space-y-2">
                    <a href="#" @click.prevent="refresh" class="text-sm font-medium cursor-pointer underline text-black">Go Back</a>
                    <span class="text-gray-500">To connect instantly instead...</span>
                </div>

            </template>

        </app-body>
        
        <AppErrorPopup 
            :show="showErrorPopup" 
            :message="errorMessage" 
            @close="closeErrorPopup" 
        />
    </app-wrapper>
</template>

<script>
import AppLogo from './../../../components/AppLogo';
import WaitingProgressBar from '../../../components/WaitingProgressBar.vue';
import AppErrorPopup from '../../../components/AppErrorPopup.vue';
import ManualBankingWarning from '../../../components/ManualBankingWarning.vue';

export default {
    mixins: [
        require('../../../mixins/InteractsWithGtag').default,
    ],
    components: {
        AppLogo, WaitingProgressBar, AppErrorPopup, ManualBankingWarning
    },
    props: {
        user: {},
        loan: {},
        manual: {
            type: Boolean,
            default: false
        },
        mxWidgetUrl: {},
        plaidLinkToken: {}
    },

    data() {
        return {
            gTagPageName: 'VERIFY_ACCOUNT',
            gEventType: 'MarketPlaceSignUp',
            showBanking: false,
            showManual: false,
            mx: null,
            plaid: null,
            institution_id: null,
            institution_code: null,
            loading: false,
            fileName: null,
            plaidLoading: false,
            manualForm: {
                errors: null,
                account_number: '',
                account_number_confirmation: '',
                routing_number: '',
                routing_number_confirmation: '',
                official_name: ''
            },
            proceeding: false,
            // for plaid asset / edge process
            attempts: 0,
            interval: null,
            maxAttempts: 12,
            // error popup state
            showErrorPopup: false,
            errorMessage: ''
        }
    },

    mounted() {
        if (this.manual) {
            this.showManual = true;
        }
    },

    watch: {
        showBanking(showBanking, oldShowBanking) {
            if (showBanking && !oldShowBanking && this.loan.banking_vendor?.name === 'mx') {
                setTimeout(() => {
                    this.mx = new window.MXConnect({
                        id: 'mx-connect-widget',
                        iframeTitle: 'Connect',
                        targetOrigin: '*',
                        onEvent: this.onMxEvent,
                        config: {ui_message_version: 4},
                    });

                    this.mx.load(this.mxWidgetUrl);
                }, 150);
            } else if (showBanking && !oldShowBanking && this.loan.banking_vendor?.name === 'plaid') {
                setTimeout(async () => {
                    const { data } = await this.$http.get(`/signup/plaid-link-token/${this.loan.id}`);

                    this.plaid = window.Plaid.create({
                        token: data.link_token,
                        onSuccess: (public_token, metadata) => {
                            this.plaidLoading = true;
                            this.proceeding = true;

                            // Track Plaid connection success
                            window.LogRocket?.track?.('verify_plaid_connection_success', {
                                    loan_id: this.loan.id,
                                    bank: metadata.institution?.name,
                                    accounts_count: metadata.accounts?.length
                                });


                            this.$http.post(`/signup/welcome/${this.loan.id}`, {
                                public_token,
                                institution: metadata.institution,
                                accounts: metadata.accounts,
                                onboarding_attempt: true,
                            }).then(() => {
                                this.startPollingEdgeStatus()
                            }).catch(error => {
                                this.plaidLoading = false;
                                this.proceeding = false;

                                // Track Plaid verification failure
                                window.LogRocket?.track?.('verify_plaid_connection_failed', {
                                        loan_id: this.loan.id,
                                        error_status: error.response?.status
                                    });


                                if (error.response && error.response.status === 422 && error.response.data?.onboarding_way) {
                                    this.showErrorPopup = true;
                                    this.errorMessage = error.response.data.onboarding_way;
                                }
                            });
                        },
                        onEvent: (event, metadata) => {
                            if (event == 'ERROR') {
                                window.Bugsnag.notify('fail Verify: ' + JSON.stringify({
                                    error: metadata.error_code + ' (' + metadata.error_message + ')',
                                    loan_id: this.loan?.id,
                                    user_id: this.user?.id,
                                }));
                            }

                            this.$http?.post('/api/plaid/link-events', {
                                event_name: event,
                                loan_id: this.loan?.id ?? null,
                                institution_name: metadata.institution_name ?? metadata.institution?.name ?? null,
                                error_type: metadata.error_type ?? null,
                                error_code: metadata.error_code ?? null,
                                error_message: metadata.error_message ?? null,
                                link_session_id: metadata.link_session_id ?? null,
                                request_id: metadata.request_id ?? null,
                                exit_status: metadata.exit_status ?? null,
                                metadata: metadata,
                                event_time: new Date().toISOString(),
                            }).catch(() => {});
                        },
                        onExit: (error, metadata) => {
                          this.plaidLoading = false;

                          // Track Plaid exit
                          window.LogRocket?.track?.('verify_plaid_exited', {
                                  loan_id: this.loan.id,
                                  has_error: !!error
                              });

                        },
                    });

                    this.plaid.open();
                }, 150);
            }
        }
    },

    methods: {
        onInstantConnectionClick() {
            window.LogRocket?.track?.('instant_bank_connection_clicked', {
                loan_id: this.loan.id,
                vendor: this.loan.banking_vendor?.name
            });
            this.showBanking = true;
        },

        onManualConnectionClick() {
            window.LogRocket?.track?.('manual_bank_connection_clicked', {
                loan_id: this.loan.id
            });
            this.showManual = true;
        },

        onBankStatementChange(e) {
            if (this.$refs['fileUpload'].files.length) {
                this.fileName = this.$refs['fileUpload'].files[0].name;

                // Track file selection
                window.LogRocket?.track?.('bank_statement_selected', {
                    loan_id: this.loan.id,
                    file_size: this.$refs['fileUpload'].files[0].size,
                    file_type: this.$refs['fileUpload'].files[0].type || 'pdf'
                });
            } else {
                this.fileName = null;
            }
        },

        onUploadClick() {
            window.LogRocket?.track?.('bank_statement_upload_clicked', {
                loan_id: this.loan.id
            });
            this.$refs['fileUpload'].click();
        },

        onSubmitManualClick() {
            window.LogRocket?.track?.('manual_bank_submit_attempted', {
                loan_id: this.loan.id,
                has_file: !!this.fileName,
                has_account_number: !!this.manualForm.account_number,
                has_routing_number: !!this.manualForm.routing_number
            });
            this.submitManual();
        },

        refresh() {
            window.location.reload();
        },

        /**
         * @param type
         * @param payload
         */
        onMxEvent(type, payload) {
            switch (type) {
                case 'mx/connect/memberError':
                case 'mx/connect/createMemberError':
                    if (
                        payload.hasOwnProperty('member')
                        && payload.member.hasOwnProperty('connection_status')
                        && payload.member.connection_status === 2
                    ) {
                        this.mxConnectDenied(payload);
                    } else {
                        window.Bugsnag.notify(new Error(`${type}: ${JSON.stringify(payload)}`));
                    }

                    break;
                case 'mx/connect/oauthError':
                    if (payload.error_reason === 'DENIED') {
                        this.mxConnectDenied(payload);
                    } else {
                        window.Bugsnag.notify(new Error(`${type}: ${JSON.stringify(payload)}`));
                    }

                    break;
                case 'mx/connect/selectedInstitution':
                    this.institution_id = payload.guid;
                    this.institution_code = payload.code;
                    break;
                case 'mx/connect/memberConnected':
                    // return this.connected(payload);
                    break;
                case 'mx/connect/connected/primaryAction':
                    return this.continue();
                case 'mx/connect/memberStatusUpdate':
                    if (payload.connection_status === 6) {
                        // Track MX connection success
                        window.LogRocket?.track?.('verify_mx_connection_success', {
                                loan_id: this.loan.id,
                                institution_id: this.institution_id,
                                institution_code: this.institution_code
                            });

                        this.mxConnected(payload);
                    }
            }
        },

        /**
         * TriggeredBankChange after they successfully connect their bank to MX.
         *
         * @param payload
         * @return {void}
         */
        mxConnected(payload) {
            this.$http.post(`/signup/verify-bank-account/mx/${this.loan.id}`, {
                ...payload,
                ...{
                    institution_guid: this.institution_id,
                    institution_code: this.institution_code,
                    onboarding_attempt: true,
                }
            });
        },

        /**
         * TriggeredBankChange after they successfully connect their bank to MX.
         *
         * @param payload
         * @return {void}
         */
        mxConnectDenied(payload) {
            this.$http.post(`/signup/verify-bank-account/${this.loan.id}/denied`).then(() => this.continue());
        },

        /**
         * @return {void}
         */
        submitManual() {
            if (!this.fileName) {
                this.manualForm.errors = { bank_statement: ['Please upload your bank statement'] };
                return;
            }

            this.loading = true;

            // Track manual bank submission attempt
            window.LogRocket?.track?.('manual_bank_submission_attempted', {
                    loan_id: this.loan.id,
                    has_bank_statement: !!this.fileName,
                    has_account_number: !!this.manualForm.account_number,
                    has_routing_number: !!this.manualForm.routing_number
                });


            let formData = new FormData();

            for (const [key, value] of Object.entries(this.manualForm)) {
                formData.append(key, value);
            }

            if (this.fileName) {
                formData.append('bank_statement', this.$refs['fileUpload'].files[0]);
            }

            formData.append("is_changing_bank_flow", false);
            formData.append("onboarding_attempt", true);

            this.$http.post(`/signup/verify-bank-account/${this.loan.id}/enter-details`, formData, {
                headers: {'Content-Type': 'multipart/form-data'}
            }).then(() => {
                this.loading = false;

                // Track successful manual bank submission
                window.LogRocket?.track?.('manual_bank_submission_success', {
                        loan_id: this.loan.id,
                        had_bank_statement: !!this.fileName
                    });


                this.continue();
            }, error => {
                this.loading = false;
                console.log(error.response.data);

                // Track failed manual bank submission
                window.LogRocket?.track?.('manual_bank_submission_failed', {
                        loan_id: this.loan.id,
                        error_status: error.response?.status,
                        error_type: error.response?.data?.onboarding_way ? 'onboarding_way' : 'validation',
                        had_bank_statement: !!this.fileName
                    });


                if (error.response.status === 422 && error.response.data?.onboarding_way) {
                    this.showErrorPopup = true;
                    this.errorMessage = error.response.data.onboarding_way;
                }

                this.manualForm.errors = error.response.data.errors;
            });
        },

        /**
         * @param {String} errorName
         * @returns {String}
         */
        getError(errorName) {
            return this.manualForm.errors
                && this.manualForm.errors[errorName]
                && this.manualForm.errors[errorName].join(', ');
        },

        /**
         * TriggeredBankChange after they've connected, and click "Continue."
         *
         * @return {void}
         */
        continue() {
            this.loading = false;
            window.location.reload();
        },

        startPollingEdgeStatus() {
          this.interval = setInterval(this.checkEdgeReport, 5000);
        },

        async checkEdgeReport() {
          this.attempts++;

          if (this.attempts >= this.maxAttempts) {
            clearInterval(this.interval)
            this.continue()
          }
  
          try {
            const response = await fetch(`/signup/edge-report-ready/${this.loan.id}`);
            const data = await response.json();
  
            if (data.edge_report_ready) {
              this.continue()
            }
          } catch (error) {
            console.error('Polling error:', error);
          }
        },

        /**
         * Close the error popup
         */
        closeErrorPopup() {
            this.showErrorPopup = false;
            this.errorMessage = '';
            this.refresh();
        },
    },

    beforeDestroy() {
      if (this.interval) clearInterval(this.interval);
    },
}
</script>
